import React, { useState } from 'react';
import styled from 'styled-components';
import Language from '../Languages';
import QuestionInformation from '../QuestionInformation';
import {
  Container,
  Content,
  CompletionCard,
  CenteredContainer,
  T1,
  Description,
  AnimatedCard,
  BottomBar,
  ButtonWrapper,
  ProgressWrapper,
  BackButton,
  NextButton,
  Progress,
  TopBanner
} from '../../styles/SurveyStyles';

const Logo = styled.img`
  height: 30px;
  position: absolute;
  top: 20px;
  left: 20px;
`;

const SurveyComplete = ({
  themeColors,
  endScreens,
  currentEndScreenIndex,
  setCurrentEndScreenIndex,
  logo,
  language,
  setLanguage,
  allLanguages
}) => {
  const [isFadingOut, setIsFadingOut] = useState(false);

  const handleNext = () => {
    if (currentEndScreenIndex < endScreens.length - 1) {
      setIsFadingOut(true);
      setTimeout(() => {
        setIsFadingOut(false);
        setCurrentEndScreenIndex(prev => prev + 1);
      }, 400);
    }
  };

  const handleBack = () => {
    if (currentEndScreenIndex > 0) {
      setIsFadingOut(true);
      setTimeout(() => {
        setIsFadingOut(false);
        setCurrentEndScreenIndex(prev => prev - 1);
      }, 400);
    }
  };

  // Handle case with no end screens
  if (!endScreens.length) {
    return (
      <Container themeColors={themeColors}>
        <CompletionCard>
          <CenteredContainer>
            <T1>Survey Complete</T1>
            <Description>
              Thank you for completing this survey. Your responses have been recorded.
            </Description>
          </CenteredContainer>
        </CompletionCard>
      </Container>
    );
  }
  
  // Get the current end screen to show
  const currentEndScreen = endScreens[currentEndScreenIndex];
  
  // If current end screen is invalid, show default completion screen
  if (!currentEndScreen || !currentEndScreen.properties || !currentEndScreen.properties.blocks) {
    return (
      <Container themeColors={themeColors}>
        <CompletionCard>
          <CenteredContainer>
            <T1>Survey Complete</T1>
            <Description>
              Thank you for completing this survey. Your responses have been recorded.
            </Description>
          </CenteredContainer>
        </CompletionCard>
      </Container>
    );
  }
  
  return (
    <Container themeColors={themeColors}>
      <TopBanner themeColors={themeColors}>
        <Logo src={logo} alt="Logo" />
        <Language language={language} setLanguage={setLanguage} allLanguages={allLanguages} />
      </TopBanner>

      <Content>
        <AnimatedCard isFadingOut={isFadingOut}>
          <QuestionInformation
            question={currentEndScreen}
            currentAnswer=""
            onAnswerChange={() => {}}  // No answer needed for end screens
          />
        </AnimatedCard>
      </Content>

      {/* Fixed bottom navigation bar for end screens */}
      <BottomBar>
        <ButtonWrapper>
          {currentEndScreenIndex > 0 ? (
            <BackButton onClick={handleBack} themeColors={themeColors}>Back</BackButton>
          ) : (
            <div style={{ width: "100px" }}></div>
          )}
        </ButtonWrapper>

        <ProgressWrapper>
          <Progress>
            End Screen {currentEndScreenIndex + 1} of {endScreens.length}
          </Progress>
        </ProgressWrapper>

        <ButtonWrapper>
          {currentEndScreenIndex < endScreens.length - 1 && (
            <NextButton onClick={handleNext} active={true} themeColors={themeColors}>
              Next
            </NextButton>
          )}
          {currentEndScreenIndex === endScreens.length - 1 && (
            <div style={{ width: "100px" }}></div>
          )}
        </ButtonWrapper>
      </BottomBar>
    </Container>
  );
};

export default SurveyComplete; 